'use client';
import React from 'react';
var InputPickerContext = /*#__PURE__*/React.createContext({
  tagProps: {},
  trigger: 'Enter'
});
export default InputPickerContext;